import axios from "axios/index";
import {getAPIUrl} from "@esnpm/node-toolbox";
import Promise from "bluebird";
export const API_SESSION_PAYMENT_CHECKOUT_CANCEL_REQUEST = "API_SESSION_PAYMENT_CHECKOUT_CANCEL_REQUEST";
export const API_SESSION_PAYMENT_CHECKOUT_CANCEL_SUCCESS = "API_SESSION_PAYMENT_CHECKOUT_CANCEL_SUCCESS";
export const API_SESSION_PAYMENT_CHECKOUT_CANCEL_FAILURE = "API_SESSION_PAYMENT_CHECKOUT_CANCEL_FAILURE";

export const api_session_payment_checkout_cancel_request = (options) => {
	return {
		type: API_SESSION_PAYMENT_CHECKOUT_CANCEL_REQUEST,
		options: options,
		payload: {
			loading: true
		}
	};
};

export const api_session_payment_checkout_cancel_success = (data) => {
	return {
		type: API_SESSION_PAYMENT_CHECKOUT_CANCEL_SUCCESS,
		payload: {
			loading: false,
			data: data,
			error: null
		}
	};
};

export const api_session_payment_checkout_cancel_failure = (error) => {
	return {
		type: API_SESSION_PAYMENT_CHECKOUT_CANCEL_FAILURE,
		payload: {
			loading: false,
			error: error
		}
	};
};

/*
	Session.apiSessionPaymentCheckoutCancel
*/
export const apiSessionPaymentCheckoutCancel = (options) =>
	// eslint-disable-next-line no-unused-vars
	(dispatch, getState) => new Promise(
		// eslint-disable-next-line no-unused-vars
		(resolve, reject) => {
			dispatch(api_session_payment_checkout_cancel_request(options));
			const url=getAPIUrl([
				{"url": "/api/session/payment/checkout/cancel", "parameters": []},
			], options);
			axios({
				method: "get",
				url: url,
				params: {
					HASH: options.HASH,
				},
			}).then(
				(response) => {
					if (response.data.SUCCESSFUL) {
						dispatch(api_session_payment_checkout_cancel_success(response.data.DATA));
						resolve();
					} else {
						dispatch(api_session_payment_checkout_cancel_failure(response.data));
						resolve();
					}
				},
				(err) => {
					// eslint-disable-next-line no-console
					console.log(err);
					reject();
				}
			);
		}
	);
